function EmbeddedPlayerModalPortal() {
    return null;
}

export default EmbeddedPlayerModalPortal;
